import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, isRef as _isRef, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/img_appointmet_description.svg'


const _withScopeId = n => (_pushScopeId("data-v-21e237ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "appointment_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"appointment_layout_step\" data-v-21e237ab><div class=\"appointment_step\" data-v-21e237ab><div class=\"appointment_step_item is-checked\" data-v-21e237ab>日時と場所</div><div class=\"appointment_step_item\" data-v-21e237ab>確認</div><div class=\"appointment_step_item\" data-v-21e237ab>完了</div></div></div><h1 class=\"appointment_title\" data-v-21e237ab><span class=\"appointment_title_text\" data-v-21e237ab>面談日の選択</span></h1>", 2)
const _hoisted_4 = { class: "appointment_layout_input" }
const _hoisted_5 = { class: "appointment_form" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "appointment_form_text" }, "面談形態を選択してください", -1))
const _hoisted_7 = { class: "appointment_form_radio" }
const _hoisted_8 = ["id", "value"]
const _hoisted_9 = ["for"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "appointment_note" }, " 現在は対面（マスメディアン面談ルーム）での面談は実施しておりません。対面での面談の環境に近いため、Web面談でのお申し込みをおすすめいたします。面談形式（Web相談、電話相談）によって内容が変わることはありません。 ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.massmedian.co.jp/information/view/90",
  class: "appointment_text_link",
  target: "_blank"
}, " Web相談・電話相談の違いについて ", -1))
const _hoisted_12 = { class: "appointment_layout_input" }
const _hoisted_13 = { class: "appointment_form" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "appointment_form_text" }, "面談場所を選択してください", -1))
const _hoisted_15 = { class: "appointment_form_select" }
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"appointment_layout_description\" data-v-21e237ab><div class=\"appointment_description\" data-v-21e237ab><img class=\"appointment_description_icon\" src=\"" + _imports_0 + "\" alt=\"\" data-v-21e237ab><p class=\"appointment_description_title\" data-v-21e237ab>面談場所は、勤務地、もしくはそれに近い地域を選択してください</p><p class=\"appointment_description_text\" data-v-21e237ab> 面談は、各地域専任のコンサルタントが担当します。同じ業界でも地域によって、仕事の流れや動き方、クライアントの種類に違いがあります。転職活動の準備をする上でも、希望勤務地に近い地域を選択することをおすすめします。 </p></div></div>", 1)
const _hoisted_17 = { class: "appointment_calendar" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "appointment_calendar_header" }, "面談日時を選択してください", -1))
const _hoisted_19 = { class: "appointment_calendar_contents" }
const _hoisted_20 = { class: "temp_calendar" }
const _hoisted_21 = { class: "appointment_calendar_contents_time" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "appointment_calendar_contents_time_text" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "appointment_calendar_contents_time_text_label" }, "時間")
], -1))
const _hoisted_23 = { class: "appointment_calendar_contents_time_input" }
const _hoisted_24 = { class: "appointment_button" }
const _hoisted_25 = { class: "appointment_button_prev" }
const _hoisted_26 = { class: "appointment_button_next" }

import { ref, Ref, watchEffect, computed, watch } from 'vue';
import { format } from 'date-fns';
import alertOnReload from '@/utils/alertOnReload';
import { useRouter } from 'vue-router';
import { useField, useForm } from 'vee-validate';
import store from '@/store';
import { initAppointmentState } from '@/store/modules/appointment';
import APPOINTMENT_PLACE from '@/constants/appointmentPlace';
import { getInterviewDate, getInterviewTime } from '@/api/interviewEndpoint';
import { getMasterDataMainRegTypeCareer, MasterDataMainRegTypeCareer } from '@/api/masterDataEndpoint';
import BaseButton from '@/components/BaseButton.vue';
import BaseSelectBox, { Options } from '@/components/BaseSelectBox.vue';
import Calendar, { CalendarEventInput } from '@/components/Calendar.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import { validationRuleHelper } from '@/utils/validationRule';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppointmentView',
  setup(__props) {

const router = useRouter();
const { meta, errors } = useForm();

// 面談形態
const {
  value: mainRegTypeId,
  errors: mainRegTypeIdErrors,
  meta: mainRegTypeIdMeta,
} = useField<string>('mainRegTypeId', validationRuleHelper({ required: true }), {
  initialValue: store.getters['appointment/mainRegTypeId'],
  bails: false,
  label: '面談形態',
});

// 面談形態候補
const mainRegTypeOption: Ref<MasterDataMainRegTypeCareer[]> = ref(store.getters['appointment/mainRegTypeOption']);

const setMainRegTypeOption = async () => {
  try {
    const res = await getMasterDataMainRegTypeCareer();
    mainRegTypeOption.value = res;
  } catch (e) {
    console.error(e, '面談時間候補一覧の取得に失敗しました');
    timeOption.value = [];
  }
};

// 面談場所
const {
  value: areaId,
  errors: areaIdErrors,
  meta: areaIdMeta,
  handleBlur: areaIdHandleBlur,
} = useField<string>('areaId', validationRuleHelper({ required: true }), {
  initialValue: store.getters['appointment/areaId'],
  bails: false,
  label: '面談場所',
});

// 面談日(元データyyyy-MM-dd)
const { value: selectedDate, errors: selectedDateErrors } = useField<string>('selectedDate', validationRuleHelper({ required: true }), {
  initialValue: store.getters['appointment/selectedDate'],
  bails: false,
  label: '面談日',
});

// 面談日(送る値yyyyMMdd)
const interviewDate = computed(() => selectedDate.value.replace(/-/g, ''));
const selectedMonth = selectedDate.value === '' ? ref(format(new Date(), 'yyyyMM')) : ref(format(new Date(selectedDate.value), 'yyyyMM'));
const calendarEvents: Ref<CalendarEventInput[]> = ref([]);
const place = computed(() => {
  return APPOINTMENT_PLACE.filter((i) => i.value === areaId.value)[0]?.label || '';
});
const setCalendar = async () => {
  const params = {
    areaId: areaId.value,
    interviewMonth: selectedMonth.value,
  };
  // パラメータが不足している場合はcalendarEventsをリセットする
  if (!params.areaId || !params.interviewMonth) {
    calendarEvents.value = [];
    return;
  }
  try {
    const res = await getInterviewDate(params);
    calendarEvents.value = res.interviewTimeList.map((i) => {
      const selectable = i.interviewTimeStatus;
      return {
        start: i.interviewTime,
        selectable,
        title: selectable ? '◯' : '×',
      };
    });
  } catch (e) {
    console.error('面談日候補一覧の取得に失敗しました', e);
    calendarEvents.value = [];
    timeOption.value = [];
  }
};

const timeOption: Ref<Options> = ref([]);

// 面談時間
const { value: interviewTime, errors: interviewTimeErrors } = useField<string>('interviewTime', validationRuleHelper({ required: true }), {
  initialValue: store.getters['appointment/interviewTime'],
  bails: false,
  label: '面談時間',
});
const interviewTimeDisplay = ref('');
const hasInterviewTimeInTimeOption = ref(false);

const setTimeOption = async () => {
  const params = {
    areaId: areaId.value,
    interviewDate: interviewDate.value,
  };
  // パラメータが不足している場合はtimeOptionをリセットする
  if (!params.areaId || !params.interviewDate) {
    timeOption.value = [];
    return;
  }
  try {
    const res = await getInterviewTime(params);
    timeOption.value = res.interviewTimeList.map((i) => {
      return {
        value: i.interviewTimeId,
        label: i.interviewTimeName,
      };
    });

    hasInterviewTimeInTimeOption.value = timeOption.value.some((i) => i.value === interviewTime.value);
    if (isErrorForNonChange.value) {
      timeOption.value.push({ value: interviewTime.value, label: interviewTimeDisplay.value });
      timeOption.value = timeOption.value.sort((a, b) => {
        return a.value < b.value ? -1 : 1;
      });
    }
  } catch (e) {
    console.error(e, '面談時間候補一覧の取得に失敗しました');
    timeOption.value = [];
  }
};

const isReserved = ref(false);

const initInterviewInfo = ref({
  mainRegTypeId: initAppointmentState.mainRegTypeId,
  areaId: initAppointmentState.areaId,
  interviewDate: initAppointmentState.interviewDate,
  interviewTime: initAppointmentState.interviewTime,
});

const getInterviewInfo = async () => {
  await store.dispatch('appointment/getInterviewInfo');
  mainRegTypeId.value = store.getters['appointment/mainRegTypeId'];
  areaId.value = store.getters['appointment/areaId'];
  selectedDate.value = store.getters['appointment/selectedDate'];
  interviewTime.value = store.getters['appointment/interviewTime'];
  interviewTimeDisplay.value = store.getters['appointment/interviewTimeDisplay'];
  isReserved.value = store.getters['appointment/reservationId'] !== null;
  initInterviewInfo.value = {
    mainRegTypeId: mainRegTypeId.value,
    areaId: areaId.value,
    interviewDate: interviewDate.value,
    interviewTime: interviewTime.value,
  };
};

/** 既存予約と変更がない場合はtrue */
const isErrorForNonChange = computed(() => {
  return (
    // NOTE: 現状、面談形態は考慮しない
    // initInterviewInfo.value.mainRegTypeId === mainRegTypeId.value &&
    initInterviewInfo.value.areaId === areaId.value &&
    initInterviewInfo.value.interviewDate === interviewDate.value &&
    initInterviewInfo.value.interviewTime === interviewTime.value &&
    isReserved.value &&
    !hasInterviewTimeInTimeOption.value
  );
});
const errorMessage = computed(() => {
  const errors = interviewTimeErrors.value;
  if (isErrorForNonChange.value) {
    errors.push('既に予約されている内容と日程が変更されていません', '面談形態のみ変更する場合は一度キャンセルして予約してください');
  }
  return errors;
});

const init = async () => {
  if (mainRegTypeOption.value.length === 0) {
    setMainRegTypeOption();
  }
  const hasInterviewInfo = !(
    mainRegTypeId.value === initAppointmentState.mainRegTypeId &&
    areaId.value === initAppointmentState.areaId &&
    interviewDate.value === initAppointmentState.interviewDate &&
    interviewTime.value === initAppointmentState.interviewTime
  );
  if (!hasInterviewInfo) {
    await getInterviewInfo();
  }
};

init();

watchEffect(() => {
  setCalendar();
  setTimeOption();
});

// 日付が変更されたら、時間をリセットする
const resetTimeValue = () => (interviewTime.value = '');
watch(selectedDate, (selectedDate, oldSelectedDate) => {
  if (oldSelectedDate !== '') {
    resetTimeValue();
  }
});

const transitionPage = () => {
  store.commit('appointment/setMainRegTypeId', mainRegTypeId.value);
  store.commit('appointment/setAreaId', areaId.value);
  store.commit('appointment/setInterviewDate', interviewDate.value);
  store.commit('appointment/setInterviewTime', interviewTime.value);
  store.commit('appointment/setMainRegTypeOption', mainRegTypeOption.value);
  router.push({ name: 'd01' });
};

const transitionPreviousPage = () => {
  window.history.back();
};

alertOnReload();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mainRegTypeOption.value, (opt) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: opt.code
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  name: "appointment_type",
                  id: `reg_type_${opt.code}`,
                  class: "appointment_radio_input",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(mainRegTypeId) ? (mainRegTypeId).value = $event : null)),
                  value: opt.code
                }, null, 8, _hoisted_8), [
                  [_vModelRadio, _unref(mainRegTypeId)]
                ]),
                _createElementVNode("label", {
                  for: `reg_type_${opt.code}`,
                  class: "appointment_radio_input_label"
                }, _toDisplayString(opt.name), 9, _hoisted_9)
              ], 64))
            }), 128))
          ])
        ]),
        (_unref(mainRegTypeIdMeta).touched && _unref(errors).mainRegTypeId)
          ? (_openBlock(), _createBlock(ErrorMessage, {
              key: 0,
              errors: _unref(mainRegTypeIdErrors)
            }, null, 8, ["errors"]))
          : _createCommentVNode("", true),
        _hoisted_10,
        _hoisted_11
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createVNode(BaseSelectBox, {
              placeholder: "面談場所を選択",
              modelValue: _unref(areaId),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(areaId) ? (areaId).value = $event : null)),
              options: _unref(APPOINTMENT_PLACE),
              onBlue: _unref(areaIdHandleBlur)
            }, null, 8, ["modelValue", "options", "onBlue"])
          ])
        ]),
        (_unref(areaIdMeta).touched && _unref(errors).areaId)
          ? (_openBlock(), _createBlock(ErrorMessage, {
              key: 0,
              errors: _unref(areaIdErrors)
            }, null, 8, ["errors"]))
          : _createCommentVNode("", true),
        _hoisted_16
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createVNode(Calendar, {
              place: _unref(place),
              calendarEvents: calendarEvents.value,
              selectedDate: _unref(selectedDate),
              "onUpdate:selectedDate": _cache[2] || (_cache[2] = ($event: any) => (_isRef(selectedDate) ? (selectedDate).value = $event : null)),
              selectedMonth: _unref(selectedMonth),
              "onUpdate:selectedMonth": _cache[3] || (_cache[3] = ($event: any) => (_isRef(selectedMonth) ? (selectedMonth).value = $event : null))
            }, null, 8, ["place", "calendarEvents", "selectedDate", "selectedMonth"])
          ]),
          (_unref(errors).selectedDate)
            ? (_openBlock(), _createBlock(ErrorMessage, {
                key: 0,
                errors: _unref(selectedDateErrors)
              }, null, 8, ["errors"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _createVNode(BaseSelectBox, {
                placeholder: "面談時間を選択",
                modelValue: _unref(interviewTime),
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(interviewTime) ? (interviewTime).value = $event : null)),
                options: timeOption.value
              }, null, 8, ["modelValue", "options"])
            ])
          ]),
          (_unref(errors).interviewTime || _unref(isErrorForNonChange))
            ? (_openBlock(), _createBlock(ErrorMessage, {
                key: 1,
                errors: _unref(errorMessage)
              }, null, 8, ["errors"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createVNode(BaseButton, {
            onClick: transitionPreviousPage,
            theme: "tertiary",
            type: "button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("戻る")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createVNode(BaseButton, {
            onClick: transitionPage,
            disabled: !_unref(meta).valid || _unref(isErrorForNonChange),
            theme: "primary",
            type: "button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("次へ")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ])
  ]))
}
}

})